<!-- Version data -->
<div class="dialog-container">
  <div class="dialog-header">
    <h5 class="dialog-title">
      {{ "last-path-notes" | translate }}
    </h5>
  </div>
  <div class="dialog-body">
    @for (patch of data.latestPatchInfo; track patch) {
      <span class="patch-date">{{ patch.date }}</span>
      @for (note of patch.info; track note) {
        <div class="patch-note">
          <span class="patch-note-title">{{ note.title }}</span>
          <ul class="patch-note-actions">
            @for (action of note.actions; track action) {
              <li>
                {{ action }}
              </li>
            }
          </ul>
        </div>
      }
    }
  </div>
  <!-- Dialog footer -->
  <div class="dialog-footer">
    <button
      mat-button
      (click)="SessionDataService.sendDialogAction({ action: 'close' })"
      >
      {{ "close" | translate }}
    </button>
  </div>
</div>
